import { api } from './api-client';

export interface ScheduledTrigger {
    id: string;
    tenantId: string;
    appId?: string;
    name: string;
    description?: string;
    triggerType: 'one_shot' | 'recurring';
    scheduleKind?: 'delay' | 'cron' | 'rrule';
    targetAction: 'invoke_capability' | 'signal_workflow';
    targetRef: string;
    targetMethod?: string;
    cronExpression?: string;
    rruleExpression?: string;
    timezone: string;
    concurrencyPolicy: string;
    misfirePolicy: string;
    enabled: boolean;
    runCount: number;
    nextRunAt?: string;
    lastRunAt?: string;
    delayUntilAt?: string;
    created: string;
    modified: string;
    inputPayload?: Record<string, unknown>;
    maxRuns?: number;
    startAt?: string;
    endAt?: string;
}

export interface ScheduledTriggerRun {
    id: string;
    scheduledTriggerId: string;
    scheduledForAt: string;
    status: string;
    attempt: number;
    claimedAt?: string;
    startedAt?: string;
    completedAt?: string;
    error?: Record<string, unknown>;
    created: string;
}

export interface ListTriggersResponse {
    data: ScheduledTrigger[];
    meta: { current_page: number; per_page: number; total: number; last_page: number };
}

export interface TriggerCreateInput {
    name: string;
    triggerType: string;
    scheduleKind?: string;
    targetAction?: string;
    targetRef: string;
    targetMethod?: string;
    cronExpression?: string;
    rruleExpression?: string;
    timezone?: string;
    concurrencyPolicy?: string;
    misfirePolicy?: string;
    enabled?: boolean;
    delayUntilAt?: string;
    inputPayload?: Record<string, unknown>;
    maxRuns?: number;
    startAt?: string;
    endAt?: string;
}

export const schedulerApi = {
    listTriggers: (params?: { page?: number; per_page?: number; enabled?: boolean; target_ref?: string }) =>
        api.get<ListTriggersResponse>('/scheduler/triggers', { params }),

    createTrigger: (input: TriggerCreateInput) =>
        api.post('/scheduler/triggers', input),

    getTrigger: (id: string) =>
        api.get<{ data: ScheduledTrigger }>(`/scheduler/triggers/${id}`),

    updateTrigger: (id: string, input: Partial<TriggerCreateInput>) =>
        api.put(`/scheduler/triggers/${id}`, input),

    deleteTrigger: (id: string) =>
        api.delete(`/scheduler/triggers/${id}`),

    pauseTrigger: (id: string) =>
        api.post(`/scheduler/triggers/${id}/pause`),

    resumeTrigger: (id: string) =>
        api.post(`/scheduler/triggers/${id}/resume`),

    fireTrigger: (id: string) =>
        api.post(`/scheduler/triggers/${id}/fire`),

    listRuns: (id: string, limit?: number) =>
        api.get<{ data: { runs: ScheduledTriggerRun[] } }>(`/scheduler/triggers/${id}/runs`, { params: { limit } }),

    previewSchedule: (input: { triggerType: string; scheduleKind?: string; cronExpression?: string; rruleExpression?: string; timezone?: string; count?: number }) =>
        api.post<{ data: { occurrences: string[]; count: number } }>('/scheduler/triggers/preview', input),
};
